import { EarningsInsightRecapResponse, EarningsItemBase } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TextSection } from '~/components/text-section/TextSection';
import { PublishedDate } from '~/widgets/earnings-insight-drawer/earnings-insight-widget/components/published-date/PublishedDate';

import { EarningsHighlightsTable } from '../earnings-highlights-table/EarningsHighlightsTable';
import * as S from './RecapOverview.styles';

interface RecapOverviewProps {
  title: string;
  earningsData: EarningsItemBase;
  recapData: EarningsInsightRecapResponse;
}

export const RecapOverview = ({
  title,
  earningsData,
  recapData,
}: RecapOverviewProps) => {
  const { t } = useTranslation(['earnings']);

  return (
    <>
      <PublishedDate
        publishedAt={recapData.created_at}
        updatedAt={recapData.updated_at}
        isPreview={false}
        fiscalYear={earningsData.fiscal_year}
        fiscalPeriod={earningsData.fiscal_period}
        releasedAt={earningsData.reporting_date}
      />
      <S.Title>{title}</S.Title>
      <EarningsHighlightsTable earningsData={earningsData} />
      <S.KeyMetricsWrapper>
        <TextSection
          title={t('earnings:earningsInsight.drawer.earningsRecap.keyMetrics')}
          variant={'secondary'}
          useBulletPoints={false}
          textContent={[recapData.key_metrics]}
        />
      </S.KeyMetricsWrapper>
      <TextSection
        title={t(
          'earnings:earningsInsight.drawer.earningsRecap.guidanceUpdate'
        )}
        variant={'secondary'}
        useBulletPoints={false}
        textContent={[recapData.guidance_update]}
      />
    </>
  );
};
